import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActivitiesPageComponent } from './pages/activities/activities-page/activities-page.component';
import { HomeComponent } from './pages/home/home.component';
// import { LoginComponent } from './pages/login/login.component';
import { PasswordRecoverComponent } from './pages/users/password-recover/password-recover.component';
import { RegisterComponent } from './pages/register/register.component';
import { RegisterMakerComponent } from './pages/register/register-maker/register-maker.component';
import { AuthGuard } from './pages/shared/auth-guard.service';
import { UsersComponent } from './shared/users/users.component';
import { TakerComponent } from './pages/taker/taker-profile/taker.component';
import { TakerAdminComponent } from './pages/taker/taker-admin.component';
import { ResetPasswordComponent } from './pages/users/reset-password/reset-password.component';
import { TakerFavoritesComponent } from './pages/taker/taker-favorites/taker-favorites.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { WordpressPageComponent } from './pages/wordpress-page/wordpress-page.component';
import { ContactFormComponent } from './pages/users/contact-form/contact-form.component';
import { RegisterResellerComponent } from './pages/register/register-reseller/register-reseller.component';
import { RedirectComponent } from './pages/shared/redirect/redirect.component';
import { ProductPageComponent } from './pages/product/product-page/product-page.component';
import { ProductPinPageComponent } from './pages/product/product-pin-page/product-pin-page.component';
import { MakerDirectories } from './pages/maker/maker-directories/maker-directories.component';
import { DestinationsComponent } from './pages/destinations/destinations.component';
import { MakerPageComponent } from './pages/maker/maker-page/maker-page.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: ':lang', component: HomeComponent },
  { path: ':lang/experiencias', component: ActivitiesPageComponent },
  { path: ':lang/destino/:destination', component: DestinationsComponent },
  { path: ':lang/makers', component: MakerDirectories },
  { path: ':lang/maker/:makerName', component: MakerPageComponent },
  { path: ':lang/product/:productName', component: ProductPageComponent },
  {
    path: ':lang/confirmar-correo',
    redirectTo: '/en?confirm=true',
    pathMatch: 'full',
  },
  // { path: ':lang/product/:productName/:id', component: ProductPageComponent },
  {
    path: ':lang/product/:productName/pin',
    component: ProductPinPageComponent,
  },
  {
    path: ':lang/taker/admin',
    component: TakerAdminComponent,
    data: { breadcrumb: 'Takers' },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'datos-acceso',
        component: UsersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'perfil',
        component: TakerComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'favoritos',
        component: TakerFavoritesComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  // { path: 'login', component: LoginComponent },
  { path: ':lang/registro', component: RegisterComponent },
  { path: ':lang/registro-maker', component: RegisterMakerComponent },
  { path: ':lang/registro-reseller', component: RegisterResellerComponent },
  { path: ':lang/recuperar-contrasena', component: PasswordRecoverComponent },
  { path: ':lang/formulario-contacto', component: ContactFormComponent },
  { path: ':lang/reset-password/:token', component: ResetPasswordComponent },
  { path: ':lang/categoria/:category', component: WordpressPageComponent },
  { path: ':lang/experiencias/:slug/redirigir', component: RedirectComponent },
  { path: ':lang/product/:productName/thank-you/:bookingId', component: ThankYouComponent },
  { path: ':lang/product/:productName/thank-you-request/:bookingId', component: ThankYouComponent }, 
  { path: ':lang/:page', component: WordpressPageComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
